// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb_container":"Breadcrumbs_breadcrumb_container__1BETk","breadcrumb_item":"Breadcrumbs_breadcrumb_item__1E4s8","breadcrumb_link":"Breadcrumbs_breadcrumb_link__3stWn"};